import React from 'react';
import CheckboxUncheckedIcon from '@atlaskit/icon/core/checkbox-unchecked';
import SingleSelectField from '@atlassian/jira-issue-create-commons/src/ui/single-select-field/index.tsx';
import type { SelectOption } from '@atlassian/jira-issue-field-select/src/ui/edit/types.tsx';
import { SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { DropdownFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { selectFieldWriter } from '../writers/index.tsx';

const SelectCustomFieldTypeComponent = (props: ProvidedFieldProps) => (
	<SingleSelectField {...props} defaultValue={undefined} />
);

export const SelectCustomFieldTypeConfig: FieldTypeConfig<SelectOption> = {
	icon: CheckboxUncheckedIcon,
	type: SELECT_CF_TYPE,
	Component: SelectCustomFieldTypeComponent,
	placeholder: <DropdownFieldPlaceholder />,
	writer: selectFieldWriter,
};
